import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js'

export const accountService = {
  // getAccounts: async () => {
  //   return [
  //     {
  //       id: '1',
  //       accountId: '123456789012',
  //       status: "completed",
  //       arn: "arn:aws:iam",
  //       aws_account_name: "Production-Server"

  //     },
  //     {
  //       id: '2',
  //       accountId: '2109876432321',
  //       status: "pending",
  //       arn: "arn:aws:iam",
  //       aws_account_name: "Production-Server"
       
  //     },
  //     {
  //       id: '3',
  //       accountId: '210987654321',
  //       status: "paused",
  //       arn: "arn:aws:iam",
  //       aws_account_name: "Production-Server"
       
  //     },
     
  //   ];
  // },
  getAccounts: async () => {
    try {
      const response = await fetchWrapper(`${API_BASE_URL}/api/v1/aws/get_all`);
      if (!response.ok) throw new Error('Failed to fetch all accounts');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching all accounts:', error);
      throw error;
    }
  },

  // Keep the old method for backward compatibility if needed
  getAccountsByClient: async (client_id) => {
    try {
      const response = await fetchWrapper(`${API_BASE_URL}/api/v1/aws/${client_id}`);
      if (!response.ok) throw new Error('Failed to fetchWrapper services');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetchWrappering services:', error);
      throw error;
    }
  },

  createAccount: async (accountData) => {
    try {

      console.log(accountData);
      const payload = accountData;
      //   const payload = {

      //     client_id: accountData.client_id || 'Vaishnavi',
      //     aws_account_name: accountData.aws_account_name || '',
      //     aws_account_id: accountData.aws_account_id || '',
      //     access_key_group: {
      //         access_key: accountData.accessKey || '',
      //         secret_key: accountData.secretKey || ''
      //     },
      //     session_group: {
      //         session_token: accountData.sessionToken || ''
      //     },
      //     external_id: accountData.externalId || false,
      //     additional_policy: (accountData.policies || []).map(policy => ({
      //         policy_name: policy.name || '',
      //         policy_document: policy.document || {},
      //         description: policy.description || ''
      //     }))
      // };

      const response = await fetchWrapper(`${API_BASE_URL}/api/v1/onboard/aws/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      console.log(response);
      if (!response.ok) {
        console.log(response.ok);
        console.log(payload);
        throw new Error('Failed to onboard account');
      }
      return await response.json();

    } catch (error) {
      console.error('Error onboarding account:', error);
      throw error;
    }
  },
};
